import { Box } from '@material-ui/core';

import { CannedResponsesPanel } from '../../CannedResponses';
import { CustomerInfo } from '../../CustomerInfo';

import { useConnect } from '../../../context/connect';

import { useStyles } from './style';

export const AgentPanel = () => {
  const classes = useStyles();
  const { agentNav } = useConnect();

  return (
    <Box className={classes.wrapper}>
      {agentNav === 'customer_info' && <CustomerInfo />}
      {agentNav === 'canned_responses' && <CannedResponsesPanel />}
    </Box>
  );
};
